import React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";

import { Button } from "../components/Button";
import { Flex } from "../components/Flex";
import { FontSize, Text } from "../components/Text";
import { Modal } from "../components/modal/Modal";
import { Info } from "../components/Info";
import { Rounded } from "../theme/Rounded";
import { Spacing } from "../theme/Spacing";
import i18n from "../i18n";
import { AppLangs } from "../model/shared/enum/AppLangs.enum";

const StyledModal = styled(Modal)`
  .ant-modal-title button {
    display: none;
  }
  .ant-modal-title p {
    margin: auto;
  }
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.main};
  text-decoration-line: underline;
  text-underline-offset: 5px;

  &:hover {
    color: ${({ theme }) => theme.main};
  }
`;

const HomeLink = styled.a`
  border-radius: ${Rounded.md};
  padding: ${Spacing.s} ${Spacing.m};
  color: ${({ theme }) => theme.sub};
  background-color: ${({ theme }) => theme.main};
  font-size: ${FontSize.m};
  text-align: center;
  margin-top: ${Spacing.s};

  &:hover {
    background-color: ${({ theme }) => theme.lightMain};
    color: ${({ theme }) => theme.sub};
  }
`;

const ContinueButton = styled(Button)`
  background-color: ${({ theme }) => theme.transparent};
  color: ${({ theme }) => theme.main};
  border: ${({ theme }) => `0.1rem solid ${theme.main}`};
  width: 100%;
`;

type MobileBlockingModalProps = {
  onContinue: VoidFunction;
};

export const MobileBlockingModal: React.FC<MobileBlockingModalProps> = ({
  onContinue,
}) => {
  const { t } = useTranslation();

  return (
    <StyledModal title={t("welcome_message")} open>
      <Flex flexDirection="column" gap="m">
        <Text align="center" color="darkerSub">
          <Trans
            i18nKey={"mobileBlock.description"}
            components={[
              <StyledLink
                target="_blank"
                rel="noreferrer"
                href="https://play.google.com/store/apps/details?id=com.atiragrup.atiraspacemobile"
              />,
            ]}
          />
        </Text>

        <Info info={t("mobileBlock.info")} />

        <HomeLink
          href={`https://www.atiraspace.com/${i18n.language !== AppLangs.EN ? i18n.language : ""}`}
        >
          {t("common.back_home")}
        </HomeLink>

        <ContinueButton margin="none" onClick={onContinue}>
          {t("mobileBlock.continue")}
        </ContinueButton>
      </Flex>
    </StyledModal>
  );
};
